import React from "react";
import { Title } from "../common/title/title";
import Search from "../common/search/search";
import { Grid } from "@material-ui/core";
import "./labourers.css";

/*
    Page component
    props:
        - id: string, id for the modal dialog
        - title: string, title for the modal dialog to show in the header
        - show: bool, show or hide the modal dialog
        - onClose: () => void
            callback to signal user requested that the dialog be closed. 
        - buttons: [] array of button elements to be shown in the dialog footer
*/

const Toolbar = (props) => {
    return (
        <div className="cmis-table-toolbar">
            <Grid container>
                <Grid
                    item
                    sm={9}
                    style={{
                        paddingLeft: 15,
                        paddingTop: 27,
                    }}>
                    <Title table>{props.title}</Title>
                </Grid>
                <Grid
                    item
                    sm={3}
                    style={{
                        paddingTop: 5,
                    }}>
                    <Search placeholder={"Search labourers"} onSearch={(val) => console.log(val)}></Search>
                </Grid>
            </Grid>
        </div>
    );
};

export default Toolbar;
